// export default function videoInit() {
//   // Получаем элементы
//   const videoWrapper = document.getElementById("videoWrapper");
//   const videoPreview = document.getElementById("videoPreview");
//   const playBtn = document.getElementById("playBtn");
//   const video = document.getElementById("mainVideo");
//   const pauseBtn = document.getElementById("pauseBtn");
//   const previewImage = document.getElementById("previewImage");

//   let isPlaying = false;

//   // Генерация превью из первого кадра
//   function generatePreviewFromVideo() {
//     const tempVideo = document.createElement("video");
//     tempVideo.preload = "auto";
//     tempVideo.muted = true;

//     const source = video.querySelector("source");

//     tempVideo.src = source ? source.src : video.src;
//     tempVideo.currentTime = 0.1;

//     tempVideo.addEventListener("loadeddata", () => {
//       const canvas = document.createElement("canvas");

//       canvas.width = tempVideo.videoWidth;
//       canvas.height = tempVideo.videoHeight;

//       const ctx = canvas.getContext("2d");

//       ctx.drawImage(
//         tempVideo,
//         0,
//         0,
//         canvas.width,
//         canvas.height
//       );

//       if (previewImage) {
//         previewImage.src =
//           canvas.toDataURL("image/jpeg", 0.8);
//       }

//       tempVideo.remove();
//     });

//     tempVideo.addEventListener("error", () => {
//       previewImage.style.display = "none";
//     });

//     tempVideo.load();
//     playBtn.style.display = "flex";
//   }

//   // Показать кнопку паузы
//   function showPauseButton() {
//     if (isPlaying) {
//       pauseBtn.classList.add("visible");
//       pauseBtn.style.display = "flex";
//     }
//   }

//   // Скрыть кнопку паузы
//   function hidePauseButton() {
//     pauseBtn.classList.remove("visible");
//   }

//   // Запуск видео
//   function startVideo() {
//     videoPreview.classList.add("hidden");
//     video.style.display = "block";

//     video
//       .play()
//       .then(() => {
//         isPlaying = true;
//         showPauseButton();
//       })
//       .catch((error) => {
//         videoPreview.classList.remove("hidden");
//         video.style.display = "none";
//       });
//   }

//   // Пауза
//   function pauseVideo() {
//     if (!isPlaying) return;

//     video.pause();
//     isPlaying = false;

//     // Скрываем кнопку паузы
//     hidePauseButton();

//     // Показываем превью
//     videoPreview.classList.remove("hidden");
//   }

//   // === Hover по wrapper ===
//   videoWrapper.addEventListener("mouseenter", () => {
//     if (isPlaying) {
//       showPauseButton();
//     }
//   });

//   videoWrapper.addEventListener("mouseleave", () => {
//     if (isPlaying) {
//       hidePauseButton();
//     }
//   });

//   // === Обработчики кликов ===
//   playBtn.addEventListener("click", (e) => {
//     e.stopPropagation();
//     startVideo();
//   });

//   videoPreview.addEventListener("click", () => {
//     if (isPlaying) {
//       pauseVideo();
//     } else {
//       startVideo();
//     }
//   });

//   video.addEventListener("click", () => {
//     if (isPlaying) {
//       pauseVideo();
//     } else {
//       startVideo();
//     }
//   });

//   pauseBtn.addEventListener("click", (e) => {
//     e.stopPropagation();
//     pauseVideo();
//   });

//   // Конец видео
//   video.addEventListener("ended", () => {
//     isPlaying = false;

//     video.style.display = "none";
//     videoPreview.classList.remove("hidden");

//     hidePauseButton();

//     video.currentTime = 0;
//   });

//   // Генерация превью
//   video.addEventListener("loadedmetadata", () => {
//     generatePreviewFromVideo();
//   });

//   // Ошибка видео
//   video.addEventListener("error", (e) => {
//     console.error("❌ Ошибка видео:", e);

//     if (previewImage) {
//       previewImage.style.display = "none";
//     }
//   });

//   // Если видео уже загружено
//   // console.log(video.readyState);
//   if (video.readyState >= 1) {
//     generatePreviewFromVideo();
//     // playBtn.style.display = "flex";
//   }

//   // playBtn.style.display = "flex";
// }

export default function videoInit() {
  const videoWrapper = document.getElementById("videoWrapper");
  const videoPreview = document.getElementById("videoPreview");
  const playBtn = document.getElementById("playBtn");
  const video = document.getElementById("mainVideo");
  const pauseBtn = document.getElementById("pauseBtn");
  const previewImage = document.getElementById("previewImage");

  let isPlaying = false;

  // -----------------------------
  // Safari / iOS detection
  // -----------------------------
  function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  // -----------------------------
  // SAFARI FIX: оставляем только MP4
  // -----------------------------
  function fixVideoForSafari() {
    if (!isSafari() && !isIOS()) return;

    const sources = video.querySelectorAll("source");

    let mp4Source = null;

    sources.forEach((s) => {
      if (s.type === "video/mp4") {
        mp4Source = s;
      }
    });

    if (!mp4Source) return;

    video.innerHTML = "";

    const newSource = document.createElement("source");
    newSource.src = mp4Source.src;
    newSource.type = "video/mp4";

    video.appendChild(newSource);

    video.load(); // важно
  }

  fixVideoForSafari();

  // -----------------------------
  // PREVIEW GENERATION (stable)
  // -----------------------------
  function generatePreviewFromVideo() {
    const tempVideo = document.createElement("video");

    tempVideo.preload = "auto";
    tempVideo.muted = true;
    tempVideo.playsInline = true;
    tempVideo.setAttribute("playsinline", "");
    tempVideo.crossOrigin = "anonymous";

    const source = video.querySelector("source");

    tempVideo.src = source ? source.src : video.src;

    let done = false;

    const cleanup = () => {
      tempVideo.pause();
      tempVideo.removeAttribute("src");
      tempVideo.load();
    };

    const drawFrame = () => {
      if (done) return;

      try {
        const canvas = document.createElement("canvas");

        canvas.width = tempVideo.videoWidth || 640;
        canvas.height = tempVideo.videoHeight || 360;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(tempVideo, 0, 0, canvas.width, canvas.height);

        const img = canvas.toDataURL("image/jpeg", 0.85);

        if (previewImage) {
          previewImage.src = img;
          previewImage.style.display = "block";
        }

        done = true;
        cleanup();

        // console.log("✅ preview generated");
      } catch (e) {
        console.error("canvas error:", e);
      }
    };

    // Safari-safe flow
    tempVideo.addEventListener("loadedmetadata", () => {
      tempVideo.currentTime = 0;
    });

    tempVideo.addEventListener("seeked", () => {
      requestAnimationFrame(drawFrame);
    });

    tempVideo.addEventListener("error", (e) => {
      console.error("preview video error:", e);
      if (previewImage) previewImage.style.display = "none";
    });

    tempVideo.load();
  }

  // -----------------------------
  // UI
  // -----------------------------
  function showPauseButton() {
    if (!isPlaying) return;
    pauseBtn.classList.add("visible");
    pauseBtn.style.display = "flex";
  }

  function hidePauseButton() {
    pauseBtn.classList.remove("visible");
    pauseBtn.style.display = "none";
  }

  // -----------------------------
  // VIDEO CONTROL
  // -----------------------------
  function startVideo() {
    videoPreview.classList.add("hidden");
    video.style.display = "block";

    video
      .play()
      .then(() => {
        isPlaying = true;
        showPauseButton();
      })
      .catch((err) => {
        console.error("play error:", err);
        videoPreview.classList.remove("hidden");
        video.style.display = "none";
      });
  }

  function pauseVideo() {
    if (!isPlaying) return;

    video.pause();
    isPlaying = false;

    hidePauseButton();
    videoPreview.classList.remove("hidden");
  }

  // -----------------------------
  // EVENTS
  // -----------------------------
  videoWrapper.addEventListener("mouseenter", () => {
    if (isPlaying) showPauseButton();
  });

  videoWrapper.addEventListener("mouseleave", () => {
    hidePauseButton();
  });

  playBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    startVideo();
  });

  videoPreview.addEventListener("click", () => {
    isPlaying ? pauseVideo() : startVideo();
  });

  video.addEventListener("click", () => {
    isPlaying ? pauseVideo() : startVideo();
  });

  pauseBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    pauseVideo();
  });

  video.addEventListener("ended", () => {
    isPlaying = false;
    video.style.display = "none";
    videoPreview.classList.remove("hidden");
    hidePauseButton();
    video.currentTime = 0;
  });

  video.addEventListener("error", (e) => {
    console.error("❌ video error:", e);
  });

  // -----------------------------
  // INIT PREVIEW
  // -----------------------------
  video.addEventListener("loadedmetadata", () => {
    generatePreviewFromVideo();
  });

  if (video.readyState >= 1) {
    generatePreviewFromVideo();
  }

  // КНОПКА PLAY ДОЛЖНА БЫТЬ ВИДНА СРАЗУ
  playBtn.style.display = "flex";
}